import React from "react";
import ReportManager, {
  extractCurrencyName,
  groupByCurrency,
  linesColumns,
  linesTransformer,
} from "commons/components/ReportManager";
import { compose, map } from "ramda";

const filters = [
  { type: "filter", name: "products", key: "product_id" },
  { type: "filter", name: "facilities", key: "purchases.facility_id" },
  {
    type: "filter",
    name: "users",
    key: "purchases.user_id",
    extras: { optionLabel: "username" },
  },
  { type: "filter", name: "suppliers", key: "purchases.supplier_id" },
  { type: "filter", name: "categories", key: "products.category_id" },
];

const columns = [
  {
    name: "code",
    type: "text",
  },
  {
    name: "name",
    type: "text",
  },
  ...linesColumns,
];

const byProductID = (record) => record.product_id + "";

export default function PurchasesByProduct() {
  return (
    <ReportManager
      filterByDate
      dateField="purchases.date"
      url="purchase-lines"
      title="purchasesByProduct"
      filters={filters}
      columns={columns}
      recordsFunc={compose(
        map(linesTransformer(byProductID, "product_id")),
        groupByCurrency
      )}
      titlesFunc={extractCurrencyName}
      totals={[
        "quantity",
        "subtotal",
        "discount",
        "total",
        "cost",
        "commission",
      ]}
    />
  );
}
